import { render, staticRenderFns } from "./ApproveLeave.vue?vue&type=template&id=532e6cd2&scoped=true"
import script from "./ApproveLeave.vue?vue&type=script&lang=js"
export * from "./ApproveLeave.vue?vue&type=script&lang=js"
import style0 from "./ApproveLeave.vue?vue&type=style&index=0&id=532e6cd2&prod&lang=scss&scoped=true"
import style1 from "./ApproveLeave.vue?vue&type=style&index=1&id=532e6cd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532e6cd2",
  null
  
)

export default component.exports